import { DesktopOnlyView, MobileOrTabletView } from 'components/Media'
import { FlexDivRowCentered } from 'components/layout/flex'
import ROUTES from 'constants/routes'
import Link from 'next/link'
import router from 'next/router'
import { memo } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import media from 'styles/media'

import Button from 'components/Button'
import { useMarketPageRoute } from 'hooks/useMarketPageRoute'
import Menu from '../AppLayout/Header/Nav/Menu'
import Nav from '../AppLayout/Header/Nav/Nav'
import Logo from '../Logo'
import MarketsMarquee from './MarketsMarquee'
import MobileHeader from './MobileHeader'

const Header = memo(({ marketsMarquee = true }: { marketsMarquee?: boolean }) => {
	const { t } = useTranslation()
	const marketPageRoute = useMarketPageRoute()

	return (
		<>
			<MainWrapper>
				<DesktopOnlyView>
					<Container $bottomBorder={!marketsMarquee}>
						<LogoContainer onClick={() => router.push(ROUTES.Home.Root)}>
							<Logo />
						</LogoContainer>
						<Links>
							<FlexDivRowCentered columnGap="24px">
								<Menu />
								<Nav />
							</FlexDivRowCentered>
							<Link href={marketPageRoute()}>
								<Button noOutline size="small">
									{t('homepage.nav.start-trade')}
								</Button>
							</Link>
						</Links>
					</Container>
					{marketsMarquee && <MarketsMarquee />}
				</DesktopOnlyView>
			</MainWrapper>
			<MobileOrTabletView>
				<MobileHeader marketsMarquee={marketsMarquee} />
			</MobileOrTabletView>
		</>
	)
})

const MainWrapper = styled.div`
	display: flex;
	flex-direction: column;
	background: ${(props) => props.theme.colors.selectedTheme.background};
	${media.lessThan('lg')`
		flex-direction: row;
		border-bottom: ${(props) => props.theme.colors.selectedTheme.landing.border};
  `}
`

const Container = styled(FlexDivRowCentered)<{ $bottomBorder?: boolean }>`
	height: 60px;
	width: 100%;
	padding: 10px 40px;
	border-bottom: ${(props) => (props.$bottomBorder ? `1px solid ${props.theme.colors.selectedTheme.newTheme.border.color}` : 'none')};
	${media.lessThan('lg')`
		margin: auto;
		padding: 10px 10px;
		padding-left: 20px;
	`}
`

const LogoContainer = styled.div`
	display: flex;
	align-items: center;
	& span {
		width: 125px;
	}
	${media.lessThan('lg')`
		& span {
			width: 120px;
		}
  	`}
`

const Links = styled.div`
	display: flex;
	flex-direction: row;
	white-space: nowrap;
	align-items: center;
	justify-content: space-between;
	width: 100%;
	z-index: 100;
`

export default Header
